import { z } from 'zod';
export const founderStageEnum = z.enum(['Hustler', 'Builder', 'Scaler']);
export const founderStageRuleValueSchema = z
    .object({
    stages: z
        .array(founderStageEnum)
        .min(1)
        .max(3)
        .refine((s) => new Set(s).size === s.length, 'stages must be unique'),
})
    .strict();
export const upsertAutoJoinRuleInputSchema = z
    .object({
    rule_type: z.literal('founder_stage'),
    rule_value: founderStageRuleValueSchema,
})
    .strict();
//# sourceMappingURL=audiences.js.map